import { useTranslation } from 'react-i18next';
import { AppLanguage } from '@anytag/shared-types';
import { Form, Icon } from '@anytag/shared-atoms';
import { localizedDateFormatter } from '@anytag/shared-utils';
import { useYoutubeAnalyticsCountriesCategoriesOptions } from '@anytag/shared-hooks';
import { SelectorField, SingleDatePickerField } from '@anytag/shared-molecules';
import { AnalyticsTrendingYoutubePostsFilterFormKeys } from './schemaTypes';

interface TemplateProps {
  onSubmit?: () => void;
}

export const Template = ({ onSubmit }: TemplateProps) => {
  const { t, i18n } = useTranslation();
  const { date, allCountryOptions, allCategoryOptions } = useYoutubeAnalyticsCountriesCategoriesOptions();

  return (
    <Form.Fields className="items-center">
      <Form.Field className="flex flex-none items-center">
        <Icon icon="trend-two-tones" size={20} variant="none" />
        <p css={{ fontSize: '18px', lineHeight: '22px', marginLeft: '8px' }}>{t('Heading.Trend Ranking')}</p>
        <p css={{ fontSize: '11px', marginLeft: '22px' }}>
          {`${t('Last Updated')}: ${localizedDateFormatter(date || null, 'PPP', i18n.language as AppLanguage)}`}
        </p>
      </Form.Field>

      <SelectorField<AnalyticsTrendingYoutubePostsFilterFormKeys>
        name="country"
        onSubmit={onSubmit}
        options={allCountryOptions}
        className="ml-auto max-w-50"
      />
      <SelectorField<AnalyticsTrendingYoutubePostsFilterFormKeys>
        name="category"
        onSubmit={onSubmit}
        className="max-w-50"
        options={allCategoryOptions}
      />
      <SingleDatePickerField<AnalyticsTrendingYoutubePostsFilterFormKeys>
        name="date"
        onSubmit={onSubmit}
        className="max-w-50"
        disabledDays={{ after: new Date() }}
      />
    </Form.Fields>
  );
};
